/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetFragmentDetailTranscriptionQueryResponse, WebAppGetFragmentDetailTranscriptionPathParams, WebAppGetFragmentDetailTranscription404 } from "../models/WebAppGetFragmentDetailTranscription";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetFragmentDetailTranscription } from "../axios/webAppGetFragmentDetailTranscription";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetFragmentDetailTranscriptionQueryKey = (id: WebAppGetFragmentDetailTranscriptionPathParams["id"]) => ["api-v2", { url: '/web-app/fragments/:id/transcription', params: {id:id} }] as const

export type WebAppGetFragmentDetailTranscriptionQueryKey = ReturnType<typeof webAppGetFragmentDetailTranscriptionQueryKey>

export function webAppGetFragmentDetailTranscriptionQueryOptions(id: WebAppGetFragmentDetailTranscriptionPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetFragmentDetailTranscriptionQueryKey(id)
        return queryOptions<WebAppGetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>, WebAppGetFragmentDetailTranscriptionQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetFragmentDetailTranscription(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get fragment transcription
 * {@link /web-app/fragments/:id/transcription}
 */
export function useWebAppGetFragmentDetailTranscription<TData = WebAppGetFragmentDetailTranscriptionQueryResponse, TQueryData = WebAppGetFragmentDetailTranscriptionQueryResponse, TQueryKey extends QueryKey = WebAppGetFragmentDetailTranscriptionQueryKey>(id: WebAppGetFragmentDetailTranscriptionPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetFragmentDetailTranscriptionQueryResponse, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetFragmentDetailTranscriptionQueryKey(id)
         

         const query = useQuery({
          ...webAppGetFragmentDetailTranscriptionQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetFragmentDetailTranscription404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}